module.exports = __webpack_public_path__ + "static/media/eple_bla-min.9aaaad83.png";